import { BarChartOption, colors } from '@creditsights/styleguide-web';
import isEmpty from 'lodash/isEmpty';
import {
  RiskDistributionDto,
  RiskDistributionGroupBy,
} from '../../../../services/dtos/riskProducts/riskDistribution.dto';

import {
  calculateBarChartAxisLabelWidth,
  getBarChartBaseConfig,
  getTooltipMarkerHtml,
} from '../../../../utils/chartUtils';

const WATCHLIST_WIDGET_NAMES = {
  DISTRIBUTION_BY_SEGMENT: 'Distribution by Segment',
  DISTRIBUTION_BY_ACR: 'Distribution by ACR',
};
export const getChartConfig = (
  data: RiskDistributionDto[] | undefined,
  widgetWidth: number
): BarChartOption | undefined => {
  if (!data || isEmpty(data)) {
    return undefined;
  }
  const baseConfig = getBarChartBaseConfig();
  return {
    ...baseConfig,
    tooltip: {
      ...baseConfig.tooltip,
      formatter: (params) => {
        return `
              ${getTooltipMarkerHtml(params[0].color)}
              <span>
                ${params[0].name}: ${params[0].value} Companies
              </span>
          `;
      },
    },
    legend: {
      ...baseConfig.legend,
      show: false,
    },
    xAxis: [
      {
        type: 'category',
        axisTick: { show: false },
        axisLabel: {
          interval: 0,
          overflow: 'truncate',
          width: calculateBarChartAxisLabelWidth(data.length, widgetWidth),
        },
        data: data.map((d) => d.key),
      },
    ],
    series: [
      {
        type: 'bar',
        data: data.map((d) => d.count),
        emphasis: {
          focus: 'series',
        },
        color: colors.cat100,
        itemStyle: {
          opacity: 0.8,
        },
      },
    ],
  };
};

export const watchlistWidgetNameGet = (selectedGroupBy: RiskDistributionGroupBy): string => {
  let widgetName = '';
  if (selectedGroupBy === RiskDistributionGroupBy.SECTOR) {
    widgetName = WATCHLIST_WIDGET_NAMES.DISTRIBUTION_BY_SEGMENT;
  } else if (selectedGroupBy === RiskDistributionGroupBy.RATING) {
    widgetName = WATCHLIST_WIDGET_NAMES.DISTRIBUTION_BY_ACR;
  }
  return widgetName;
};
